import React from "react";
import { Link } from "react-scroll";

import * as S from "./styles";

import Logo from "../../assets/logo_black.png";
import { useScreenSize } from "../../hooks/useScreenSize";
import { useState } from "react";
import { useEffect } from "react";

const Header = () => {
	const dimension = useScreenSize();
  const [isWindowYOffset, setIsWindowYOffset] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', ()=>{
      if(window.pageYOffset > 100) {
        setIsWindowYOffset(true)
      } else {
        setIsWindowYOffset(false)
      }
    })
  }, [])
  return (
    <S.Header className={isWindowYOffset && 'nav-position'}>
      <div className="container">
        <nav className="navbar">
          <Link className="brand" href="#!" to="toRegister">
            <img src={Logo} alt="Estácio" />
          </Link>
          <ul className="menu">
            <li>
              <Link href="#!" activeClass={'active'} to="toMission" smooth={true} offset={-95}>Expedição ENEMVERSO</Link>
            </li>
            <li>
              <Link href="#!" activeClass={'active'} to="toManual" smooth={true} offset={dimension.width <= 1366 ? -95 : -120}>E-book</Link>
            </li>
            <li>
              <Link href="#!" activeClass={'active'} to="toExtra" smooth={true} offset={-95}>Conteúdos extras</Link>
            </li>
            <li>
              <Link href="#!" activeClass={'active'} to="toDoubts" smooth={true} offset={-95}>Dúvidas</Link>
            </li>
            <li>
              <Link href="#!" activeClass={'active'} to="toRegister" smooth={true}>Cadastre-se</Link>
            </li>
            <li>
              <Link href="#!" activeClass={'active'} to="alreadyRegistered" smooth={true} offset={dimension.width <= 1366 ? -120 : -165}>Já sou cadastrado</Link>
            </li>
          </ul>
        </nav>
      </div>
    </S.Header>
  );
};

export default Header;
